import { render, staticRenderFns } from "./LessonScript.vue?vue&type=template&id=bbb36e9a"
import script from "./LessonScript.vue?vue&type=script&lang=js"
export * from "./LessonScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports